export enum CollateralMappingStatus {
    auto = 'auto',
    manual = 'manual',
    actionReview = 'actionReview',
    error = 'error',
}
